import React from 'react';
import { Spin, Empty } from 'antd';
import { usePageManager } from '../../contexts/PageManager/Provider';
import TableContainer from './components/TableContainer';
import Pagination from './components/Pagination';

export default function Content() {
  const { loadingTemplates, templates } = usePageManager();

  if (loadingTemplates) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          padding: '8px',
          height: '100px',
        }}
      >
        <Spin />
      </div>
    );
  }

  if (templates.length === 0) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          padding: '8px',
          height: '100px',
        }}
      >
        <Empty />
      </div>
    );
  }

  return (
    <>
      <TableContainer />
      <Pagination />
    </>
  );
}
